<div class="flex items-start space-x-4 text-15">
  <svg-icon src="assets/images/svg-icons/icon-yes.svg" [svgStyle]="{ 'width.px': '24' }"></svg-icon>
  <div class="mx-4" [ngClass]="{ 'font-extrabold': block.strong }">
    <div [innerHTML]="block.title" class="pricing_block_title"></div>
    <div *ngIf="block.text" [innerHTML]="block.text" class="text-12"></div>
  </div>
</div>
